import { fmtEUR, fmtDate } from "@/lib/api";
import { shortConcept } from "@/lib/utils";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Undo2 } from "lucide-react";
import { SortableHead } from "./shared";

export function ReconciledTable({ rows, totalCount, canAct, focusTx, sort, clickSort, onUnreconcile }) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <SortableHead label="Fecha mov." sortKey="date" defDir="desc" sort={sort} clickSort={clickSort} testid="recon-sort-done-date" />
              <SortableHead label="Concepto" sortKey="concept" sort={sort} clickSort={clickSort} testid="recon-sort-done-concept" />
              <SortableHead label="Facturas" sortKey="invoices" sort={sort} clickSort={clickSort} testid="recon-sort-done-invoices" />
              <SortableHead label="Importe" sortKey="amount" sort={sort} clickSort={clickSort} testid="recon-sort-done-amount" right />
              <SortableHead label="Tipo" sortKey="type" sort={sort} clickSort={clickSort} testid="recon-sort-done-type" />
              <TableHead className="text-right"></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((r) => (
              <TableRow key={r.id} data-testid={`recon-done-${r.id}`}
                className={r.bank_transaction_id === focusTx ? "bg-amber-50 ring-1 ring-amber-300" : undefined}>
                <TableCell className="text-sm">{fmtDate(r.tx_date)}</TableCell>
                <TableCell className="text-sm max-w-64 truncate" title={r.tx_concept}>{shortConcept(r.tx_concept)}</TableCell>
                <TableCell className="text-xs text-slate-600">
                  {(r.invoices_info || []).map((i) => `${i.supplier_name} ${i.invoice_number || ""}`).join(" + ")}
                </TableCell>
                <TableCell className="text-right font-num font-semibold">{fmtEUR(r.amount)}</TableCell>
                <TableCell>
                  <Badge variant="outline" className={r.type === "auto" ? "text-green-700 border-green-200 bg-green-50" : "text-blue-700 border-blue-200 bg-blue-50"}>
                    {r.type === "auto" ? `Auto ${r.score}` : "Manual"}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  {canAct && (
                    <Button data-testid={`recon-undo-${r.id}`} size="sm" variant="outline"
                      className="text-red-700 border-red-200 hover:bg-red-50 gap-1"
                      onClick={() => onUnreconcile(r.bank_transaction_id)}>
                      <Undo2 className="w-3.5 h-3.5" /> Desconciliar
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={6} className="text-center py-10 text-slate-400 text-sm">
                {totalCount === 0 ? "Aún no hay conciliaciones." : "Ninguna conciliación coincide con la búsqueda."}
              </TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
